import { styled } from '@mui/material';

export const sidebarWidth = 240;

export const MainContent = styled('main', {
  shouldForwardProp: (prop) => prop !== 'open',
})<{ open?: boolean }>(({ theme, open }) => ({
  flexGrow: 1,
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${sidebarWidth}px`,
  paddingTop: theme.spacing(12),
  width: `calc(100% - ${sidebarWidth}px)`,
  ...(open && {
    width: `calc(100% - ${sidebarWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),

    [theme.breakpoints.up('md')]: {
      marginLeft: 0,
    },
  }),
}));
